import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const emergencyContact = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the emergency contact.'),

    phoneNumber: z
      .string()
      .nullable()
      .optional()
      .describe('Phone number with country code.'),

    relationship: z
      .enum(['Parent', 'Family member', 'Friend', 'Relative'])
      .nullable()
      .optional()
      .describe('Relationship to the candidate.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Emergency contact information for a candidate.')
  .as('EmergencyContact');

export { emergencyContact as emergencyContactSchema };
